import * as types from './types';
import {
  ShopEntity,
  shopInitialEntity,
  ShopMenuEntity,
  shopMenuInitialEntity,
} from 'src/firebase/db/Shops';
import { ShopBagEntity } from 'src/firebase/db/ShopBags';
import { APISuccessfulResponse, APIFailedResponse } from 'src/firebase/db/DatabaseAdapter';
import { ValidationResponse } from 'src/firebase/db/ValidationManager';

export type Actions =
  | GetShops
  | SuccessGetShops
  | FailGetShops
  | SetDraft
  | CreateShop
  | SuccessCreateShop
  | FailCreateShop
  | UpdateShop
  | SuccessUpdateShop
  | FailUpdateShop
  | UpdateShopBags
  | SuccessUpdateShopBags
  | FailUpdateShopBags
  | SetDraftMenu
  | CreateShopMenu
  | SuccessCreateShopMenu
  | FailCreateShopMenu
  | GetShop
  | SuccessGetShop
  | FailGetShop
  | EditShopMenu
  | SuccessEditShopMenu
  | FailEditShopMenu
  | UpdateMailSenders
  | SuccessUpdateMailSenders
  | FailUpdateMailSenders
  | InitShop;
/**
 * Get
 */
interface GetShops {
  type: typeof types.GET_SHOPS;
}
export const getShops = () => ({
  type: types.GET_SHOPS,
});

interface SuccessGetShops {
  type: typeof types.SUCCESS_GET_SHOPS;
  payload: APISuccessfulResponse<ShopEntity[]>;
}
export const successGetShops = (payload: SuccessGetShops['payload']) => ({
  type: types.SUCCESS_GET_SHOPS,
  payload,
});

interface FailGetShops {
  type: typeof types.FAIL_GET_SHOPS;
  payload: ValidationResponse | APIFailedResponse;
}
export const failGetShops = (payload: FailGetShops['payload']) => ({
  type: types.FAIL_GET_SHOPS,
  payload,
});

/**
 * Draft
 */
interface SetDraft {
  type: typeof types.SET_DRAFT;
  payload: ShopEntity;
}
export function setDraft(payload?: SetDraft['payload']) {
  return {
    type: types.SET_DRAFT,
    payload: payload || shopInitialEntity,
  };
}

/**
 * Create
 */
interface CreateShop {
  type: typeof types.CREATE_SHOP;
  payload: ShopEntity;
}
export function createShop(payload: CreateShop['payload']) {
  return {
    type: types.CREATE_SHOP,
    payload,
  };
}

interface SuccessCreateShop {
  type: typeof types.SUCCESS_CREATE_SHOP;
  payload: APISuccessfulResponse<ShopEntity>;
}
export function successCreateShop(payload: SuccessCreateShop['payload']) {
  return {
    type: types.SUCCESS_CREATE_SHOP,
    payload,
  };
}

interface FailCreateShop {
  type: typeof types.FAIL_CREATE_SHOP;
  payload: ValidationResponse | APIFailedResponse;
}
export function failCreateShop(payload: FailCreateShop['payload']) {
  return {
    type: types.FAIL_CREATE_SHOP,
    payload,
  };
}

/**
 * Update
 */
interface UpdateShop {
  type: typeof types.UPDATE_SHOP;
  payload: ShopEntity;
}
export function updateShop(payload: UpdateShop['payload']) {
  return {
    type: types.UPDATE_SHOP,
    payload,
  };
}

interface SuccessUpdateShop {
  type: typeof types.SUCCESS_UPDATE_SHOP;
  payload: APISuccessfulResponse<ShopEntity>;
}
export function successUpdateShop(payload: SuccessUpdateShop['payload']) {
  return {
    type: types.SUCCESS_UPDATE_SHOP,
    payload,
  };
}

interface FailUpdateShop {
  type: typeof types.FAIL_UPDATE_SHOP;
  payload: ValidationResponse | APIFailedResponse;
}
export function failUpdateShop(payload: FailUpdateShop['payload']) {
  return {
    type: types.FAIL_UPDATE_SHOP,
    payload,
  };
}

/**
 * Update (bags only)
 */
interface UpdateShopBags {
  type: typeof types.UPDATE_SHOP_BAGS;
  payload: {
    id: string;
    query: ShopBagEntity[];
  };
}
export function updateShopBags(payload: UpdateShopBags['payload']) {
  return {
    type: types.UPDATE_SHOP_BAGS,
    payload,
  };
}

interface SuccessUpdateShopBags {
  type: typeof types.SUCCESS_UPDATE_SHOP_BAGS;
  payload: APISuccessfulResponse<{ id: string }>;
}
export function successUpdateShopBags(payload: SuccessUpdateShopBags['payload']) {
  return {
    type: types.SUCCESS_UPDATE_SHOP_BAGS,
    payload,
  };
}

interface FailUpdateShopBags {
  type: typeof types.FAIL_UPDATE_SHOP_BAGS;
  payload: ValidationResponse | APIFailedResponse;
}
export function failUpdateShopBags(payload: FailUpdateShopBags['payload']) {
  return {
    type: types.FAIL_UPDATE_SHOP_BAGS,
    payload,
  };
}

/**
 * Draft
 */
interface SetDraftMenu {
  type: typeof types.SET_DRAFT_MENU;
  payload: ShopMenuEntity;
}
export function setDraftMenu(payload?: SetDraftMenu['payload']) {
  return {
    type: types.SET_DRAFT_MENU,
    payload: payload || shopMenuInitialEntity,
  };
}

/**
 * Create Menu
 */
interface CreateShopMenu {
  type: typeof types.CREATE_SHOP_MENU;
  payload: {
    doc_id: string;
    query: ShopMenuEntity;
  };
}
export function createShopMenu(payload: CreateShopMenu['payload']) {
  return {
    type: types.CREATE_SHOP_MENU,
    payload,
  };
}

interface SuccessCreateShopMenu {
  type: typeof types.SUCCESS_CREATE_SHOP_MENU;
  payload: APISuccessfulResponse<ShopEntity>;
}
export function successCreateShopMenu(payload: SuccessCreateShopMenu['payload']) {
  return {
    type: types.SUCCESS_CREATE_SHOP_MENU,
    payload,
  };
}

interface FailCreateShopMenu {
  type: typeof types.FAIL_CREATE_SHOP_MENU;
  payload: ValidationResponse | APIFailedResponse;
}
export function failCreateShopMenu(payload: FailCreateShopMenu['payload']) {
  return {
    type: types.FAIL_CREATE_SHOP_MENU,
    payload,
  };
}

/**
 * Get
 */
interface GetShop {
  type: typeof types.GET_SHOP;
  payload: string;
}
export const getShop = (payload: GetShop['payload']) => ({
  type: types.GET_SHOP,
  payload,
});

interface SuccessGetShop {
  type: typeof types.SUCCESS_GET_SHOP;
  payload: APISuccessfulResponse<ShopEntity>;
}
export const successGetShop = (payload: SuccessGetShop['payload']) => ({
  type: types.SUCCESS_GET_SHOP,
  payload,
});

interface FailGetShop {
  type: typeof types.FAIL_GET_SHOP;
  payload: ValidationResponse | APIFailedResponse;
}
export const failGetShop = (payload: FailGetShop['payload']) => ({
  type: types.FAIL_GET_SHOP,
  payload,
});

/**
 * Edit Menu
 */
interface EditShopMenu {
  type: typeof types.EDIT_SHOP_MENU;
  payload: {
    doc_id: string;
    menu_id: string;
    query: ShopMenuEntity;
  };
}
export function editShopMenu(payload: EditShopMenu['payload']) {
  return {
    type: types.EDIT_SHOP_MENU,
    payload,
  };
}

interface SuccessEditShopMenu {
  type: typeof types.SUCCESS_EDIT_SHOP_MENU;
  payload: APISuccessfulResponse<ShopEntity>;
}
export function successEditShopMenu(payload: SuccessEditShopMenu['payload']) {
  return {
    type: types.SUCCESS_EDIT_SHOP_MENU,
    payload,
  };
}

interface FailEditShopMenu {
  type: typeof types.FAIL_EDIT_SHOP_MENU;
  payload: ValidationResponse | APIFailedResponse;
}
export function failEditShopMenu(payload: FailEditShopMenu['payload']) {
  return {
    type: types.FAIL_EDIT_SHOP_MENU,
    payload,
  };
}

/**
 * Update Mail Senders
 */
interface UpdateMailSenders {
  type: typeof types.UPDATE_MAIL_SENDERS;
  payload: {
    doc_id: string;
    method: 'add' | 'delete';
    address: string;
  };
}
export function updateMailSenders(payload: UpdateMailSenders['payload']) {
  return {
    type: types.UPDATE_MAIL_SENDERS,
    payload,
  };
}

interface SuccessUpdateMailSenders {
  type: typeof types.SUCCESS_UPDATE_MAIL_SENDERS;
  payload: APISuccessfulResponse<ShopEntity>;
}
export function successUpdateMailSenders(payload: SuccessUpdateMailSenders['payload']) {
  return {
    type: types.SUCCESS_UPDATE_MAIL_SENDERS,
    payload,
  };
}

interface FailUpdateMailSenders {
  type: typeof types.FAIL_UPDATE_MAIL_SENDERS;
  payload: ValidationResponse | APIFailedResponse;
}
export function failUpdateMailSenders(payload: FailUpdateMailSenders['payload']) {
  return {
    type: types.FAIL_UPDATE_MAIL_SENDERS,
    payload,
  };
}

/**
 * Init state
 */
interface InitShop {
  type: typeof types.INIT_SHOP;
}
export const initShop = () => ({
  type: types.INIT_SHOP,
});
